import { Chip } from '@mui/material';

// Filter chip that supports multi-select styling and toggling
const ReportChip = ({ item, total = 0, selected = false, onToggle, isMobile, chipWidth }) => {
  const label = `${item?.name ?? ''} (${total})`;

  const base = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    mt: {
      xs: '0px',
      sm: '0px',
      md: '0px'
    },
    bgcolor: 'transparent !important',
    borderRadius: '24px',
    border: '1px solid #71767A',
    '& .MuiChip-label': {
      fontWeight: 400,
      fontSize: '12px',
      color: 'var(--black-heading-text-icons, #000)',
      lineHeight: '140%',
      fontFamily: 'Noto Sans',
      fontStyle: 'normal',
      leadingTrim: 'both',
      textEdge: 'cap',
      padding: {
        xs: '8px 12px',
        sm: '8px 14px',
        md: '8px 12px'
      },
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    width: chipWidth || {
      xs: '100%',
      sm: 'auto',
      md: 'auto'
    },
    height: {
      xs: '32px',
      sm: '36px',
      md: '32px'
    },
    textAlign: {
        xs: 'left',
        sm: 'left',
        md: 'left'
    },
    justifyContent: {
      xs: 'flex-start',
      sm: 'flex-start',
      md: 'flex-start'
    },
    boxSizing: 'border-box',
    '&:hover': {
      bgcolor: '#D8E6FF !important',
      border: '1px solid #001A47'
    },
  };

  const selectedSx = {
    ...base,
    bgcolor: '#001A47 !important',
    border: '1px solid #001A47',
    '& .MuiChip-label': {
      ...base['& .MuiChip-label'],
      color: '#FFFFFF',
    },
    '&:hover': {
      bgcolor: '#001A47 !important'
    }
  };

  return (
    <Chip
      label={label}
      clickable
      onClick={(e) => { 
        e.currentTarget.blur(); 
        onToggle && onToggle(); 
      }}
      sx={selected ? selectedSx : base}
    />
  );
};

export default ReportChip;